import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import SuperAdminSidebar from '../../super_admin/SuperAdminSidebar';
import { useAuth } from '../../contexts/AuthContext';

interface LayoutProps {
    children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const location = useLocation();
    const { user } = useAuth();

    const getPageTitle = (pathname: string) => {
        switch (pathname) {
            case '/dashboard':
                return 'Dashboard';
            case '/students':
                return 'Student Management';
            case '/teachers':
                return 'Teacher Management';
            case '/staff':
                return 'Staff Management';
            case '/settings':
                return 'Settings';
            default:
                return 'Education Management System';
        }
    };

    const isSuperAdmin = user?.role === 'super_admin';

    return (
        <div className={`h-screen flex overflow-hidden ${
            isSuperAdmin 
                ? 'bg-slate-950 text-slate-100' 
                : 'bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50'
        }`}>
            {isSuperAdmin ? (
                <SuperAdminSidebar
                    isOpen={sidebarOpen}
                    onClose={() => setSidebarOpen(false)}
                    currentPath={location.pathname}
                />
            ) : (
                <Sidebar
                    isOpen={sidebarOpen}
                    onClose={() => setSidebarOpen(false)}
                    currentPath={location.pathname}
                />
            )}

            <div className={`flex-1 flex flex-col min-w-0 ${isSuperAdmin ? 'bg-slate-950' : ''}`}>
                <Header
                    onMenuClick={() => setSidebarOpen(true)}
                    title={getPageTitle(location.pathname)}
                />

                <main className={`flex-1 overflow-y-auto p-6 ${
                    isSuperAdmin ? 'custom-scrollbar super-admin-root bg-slate-950' : ''
                }`}>
                    <div className="max-w-8xl mx-auto">
                        {children}
                    </div>
                </main>
            </div>
        </div>
    );
};

export default Layout;
